import { useMemo } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { TValidationMethodConfig } from 'js/utils/Validation/types';
import { money, range, required, func } from 'js/utils/Validation/validationRules';

import * as Types from './types';

export const useValidationConfig = (
    { balance, amounts, allowedAmount }: Types.IValidationConfigParams
) => {
    const translate = useTranslations();

    return useMemo((): Record<string, TValidationMethodConfig[]> => ({
        amount: [
            required({ error: 'playtech.mobile.system.tooltip.required' }) as TValidationMethodConfig,
            func({
                fn: () => {
                    return allowedAmount === 0 ? ['playtech.mobile.system.user.tooltip.bonusMinAmount'] : null;
                }
            }) as TValidationMethodConfig,
            money() as TValidationMethodConfig,
            range({
                min: 0,
                max: balance,
                error: 'playtech.mobile.system.user.tooltip.bonusMinAmount'
            }) as TValidationMethodConfig,
            ...amounts.map(({ fromAmount, toAmount }) => range({
                min: fromAmount,
                max: toAmount,
                error: `${translate('playtech.mobile.system.tooltip.buyInBetween')} ${fromAmount}-${toAmount}`
            }) as TValidationMethodConfig)
        ],
        terms: [
            required({
                predicate: (value: boolean) => value,
                error: 'playtech.mobile.system.user.tooltip.terms.required'
            }) as TValidationMethodConfig
        ]
    }), [translate, balance, amounts, allowedAmount]);
};
